/* eslint-disable unicorn/filename-case */
import React, { useContext, useEffect, useState } from 'react'
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from './TWIAAccountHolderEdit.metadata.json5';
import styles from './TWIAAccountHolderEdit.module.scss';
import './TWIAAccountHolderEdit.messages';

function TWIAAccountHolderEdit(props) {
    const { id, fieldLabel, submissionVM, updateWizardData, editPrimaryName, setEditPrimaryName } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        isComponentValid,
        onValidate,
    } = useValidation(id);

    const [originalName, setOriginalName] = useState();

    const accountHolder = _.get(submissionVM, 'baseData.accountHolder')


    useEffect(() => {
        if (editPrimaryName) {
            if (_.get(accountHolder, 'subtype.value') === 'Person') {
                setOriginalName({ firstName: _.get(accountHolder, 'firstName.value'), lastName: _.get(accountHolder, 'lastName.value') })
            } else if (_.get(accountHolder, 'subtype.value') === 'Company') {
                setOriginalName({ companyName: _.get(accountHolder, 'contactName.value') })

            }
        }
    }, [accountHolder, editPrimaryName])

    const getAccountHolderName = () => {
        const accountHolderVM = _.get(submissionVM, 'baseData.accountHolder')

        if (_.get(accountHolderVM, 'subtype.value') === 'Person') {
            return `${_.get(accountHolderVM, 'firstName.value')} ${_.get(accountHolderVM, 'lastName.value')}`
        }

        if (_.get(accountHolderVM, 'subtype.value') === 'Company') {
            return _.get(accountHolderVM, 'contactName.value')
        }
    }

    const onEditAccountHolder = () => {
        setEditPrimaryName(true);
        // DE15325
        _.set(submissionVM, 'isEditingPrimaryName', true)
        updateWizardData(submissionVM)
    }

    const onCancelEdit = () => {
        if (_.get(accountHolder, 'subtype.value') === 'Person') {
            _.set(submissionVM, 'baseData.accountHolder.firstName.value', originalName.firstName)
            _.set(submissionVM, 'baseData.accountHolder.lastName.value', originalName.lastName)
        } else if (_.get(accountHolder, 'subtype.value') === 'Company') {
            _.set(submissionVM, 'baseData.accountHolder.contactName.value', originalName.companyName)
        }

        updateWizardData(submissionVM)
        setEditPrimaryName(false);
    }

    const onSaveEdit = () => {
        // DE15321
        if (isComponentValid) {
            setEditPrimaryName(false);
        }
    }

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true,

        },
        accountHolderLabel: {
            content: translator(fieldLabel)
        },
        accountHolderName: {
            content: getAccountHolderName()
        },
        accountHolderNameReadonly: {
            visible: !editPrimaryName
        },
        accountHolderEditContainer: {
            visible: editPrimaryName
        },
        accountHolderPersonContainer: {
            visible: _.get(accountHolder, 'subtype.value') === 'Person'
        },
        accountHolderCompanyContainer: {
            visible: _.get(accountHolder, 'subtype.value') === 'Company'
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            onEditAccountHolder,
            onSaveEdit,
            onCancelEdit
        },
        resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={submissionVM}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={onValidate}
        />
    )
}

export default TWIAAccountHolderEdit